// map
export const GET_MAPS = "GET_MAPS";
export const GET_MAIN_MAP_MOVE_END = "GET_MAIN_MAP_MOVE_END";
export const GET_REMOVE_MAP = "GET_REMOVE_MAP";
export const GET_MAP_REFRESH_DATA = "GET_MAP_REFRESH_DATA";
export const GET_MAP_PING = "GET_MAP_PING";
export const GET_RESET_MAP_ICONS = "SET_RESET_MAP_ICONS";

// places
export const GET_PLACES = "GET_PLACES";
export const GET_PLACES_DETAILS = "GET_PLACES_DETAILS";
export const GET_PLACES_REFRESH_MAP = "GET_PLACES_REFRESH_MAP";

// grids
export const GET_STABILITY_PARAMS = "GET_STABILITY_PARAMS";
export const GET_STABILITY_REFRESH_MAP = "GET_STABILITY_REFRESH_MAP";

// hotspots
export const GET_HOTSPOTS = "GET_HOTSPOTS";
export const GET_HOTSPOTS_PARAMS = "GET_HOTSPOTS_PARAMS";
export const GET_HOTSPOTS_REFRESH_MAP = "GET_HOTSPOTS_REFRESH_MAP";
export const GET_HOTSPOTS_DETAILS = "GET_HOTSPOTS_DETAILS";
export const GET_HOTSPOTS_DETAILS_SELECTED_TAB =
  "GET_HOTSPOTS_DETAILS_SELECTED_TAB";
export const GET_HOTSPOTS_DETAILS_PARAMS = "GET_HOTSPOTS_DETAILS_PARAMS";

// news
export const GET_NEWS_REFRESH_MAP = "GET_NEWS_REFRESH_MAP";

// Social
export const GET_SOCIAL_REFRESH_MAP = "GET_SOCIAL_REFRESH_MAP";

// home
export const GET_LOADING = "GET_LOADING";
export const GET_LOCKED_FEATURES = "GET_LOCKED_FEATURES";
export const GET_AUTO_REFRESH_ENABLED = "GET_AUTO_REFRESH_ENABLED";
export const GET_NOTIFIER = "GET_NOTIFIER";
export const GET_SELECTOR_PANEL = "GET_SELECTOR_PANEL";
export const GET_SELECTED_DATES = "GET_SELECTED_DATES";
export const GET_DETAILS_SIDEBAR = "GET_DETAILS_SIDEBAR";
export const GET_INFO_VIEWER_ITEMS = "GET_INFO_VIEWER_ITEMS";
export const GET_INFO_VIEWER_REFRESH = "GET_INFO_VIEWER_REFRESH";
export const SAVE_CLICK_STREAM_EVENT = "SAVE_CLICK_STREAM_EVENT";

// user
export const GET_PREFERENCES = "GET_PREFERENCES";
export const SAVE_PREFERENCES = "SAVE_PREFERENCES";
export const GET_PROFILE = "GET_PROFILE";
export const GET_GROUP_MEMBERS = "GET_GROUP_MEMBERS";

// events
export const GET_TOPICS_V2_REFRESH_MAP = "GET_TOPICS_V2_REFRESH_MAP";
export const GET_TOPICS_V2_MAP_TOPIC = "GET_TOPICS_V2_MAP_TOPIC";

// alerts
export const GET_USER_ALERTS = "GET_USER_ALERTS";
export const GET_ALERT_LOADING = "GET_ALERT_LOADING";
export const SAVE_MAPPED_ALERTS = "SAVE_MAPPED_ALERTS";
export const DELETE_USER_ALERT = "DELETE_USER_ALERT";
export const DELETE_SHARED_ALERT = "DELETE_SHARED_ALERT";
export const SAVE_USER_ALERT = "SAVE_USER_ALERT";
export const OPEN_ALERT_WIZARD = "OPEN_ALERT_WIZARD";
export const CLOSE_ALERT_WIZARD = "CLOSE_ALERT_WIZARD";
export const GET_ALERTS_REFRESH_MAP = "GET_ALERTS_REFRESH_MAP";
export const GET_TRIGGERED_ALERTS = "GET_TRIGGERED_ALERTS";
export const CLEAR_TRIGGERED_ALERTS = "CLEAR_TRIGGERED_ALERTS";
export const GET_USER_ALERTED_CONTENT_ACTION =
  "GET_USER_ALERTED_CONTENT_ACTION";
export const ADD_TRIGGERED_ALERT = "ADD_TRIGGERED_ALERT";
export const ADD_TRIGGERED_ALERTS = "ADD_TRIGGERED_ALERTS";
export const REMOVE_TRIGGERED_ALERT = "REMOVE_TRIGGERED_ALERT";

// alerted content
export const SET_TIME_WINDOW_DETAILS = "SET_TIME_WINDOW_DETAILS";
export const GET_USER_ALERTED_CONTENT = "GET_USER_ALERTED_CONTENT";
export const GET_USER_MAPPED_CONTENT = "GET_USER_MAPPED_CONTENT";

// search location
export const GET_SEARCH_KEYWORD = "GET_SEARCH_KEYWORD";
export const GET_SEARCH_LOCATION = "GET_SEARCH_LOCATION";
export const GET_SEARCH_LOCATION_REFRESH_MAP =
  "GET_SEARCH_LOCATION_REFRESH_MAP";
export const GET_SEARCH_ENABLED_ITEMS = "GET_SEARCH_ENABLED_ITEMS";
export const GET_SEARCH_DETAILS = "GET_SEARCH_DETAILS";
export const GET_SEARCH_TYPE = "GET_SEARCH_TYPE";
export const GET_SEARCH_BOUNDS = "GET_SEARCH_BOUNDS";
export const GET_SEARCH_LOADING = "GET_SEARCH_LOADING";

// monitor
export const GET_MONITOR_STABILITY = "GET_MONITOR_STABILITY";
export const GET_MONITOR_ENABLED = "GET_MONITOR_ENABLED";

// collaboration
export const GET_COLLABORATION_FOLDERS = "GET_COLLABORATION_FOLDERS";
export const GET_COLLABORATION_FOLDERS_CHANGED =
  "GET_COLLABORATION_FOLDERS_CHANGED";

export const GET_DAY_NIGHT_OVERLAY_REFRESH_MAP =
  "GET_DAY_NIGHT_OVERLAY_REFRESH_MAP";

export const GET_FIREBASE_ENABLED = "GET_FIREBASE_ENABLED";

export const GET_ALERT_PUSH_TIMESTAMP = "GET_ALERT_PUSH_TIMESTAMP";

// saved search
export const GET_SAVED_SEARCH_QUERIES = "GET_SAVED_SEARCH_QUERIES";
export const SAVE_SEARCH_QUERY = "SAVE_SEARCH_QUERY";
export const DELETE_SAVED_SEARCH_QUERY = "DELETE_SAVED_SEARCH_QUERY";
export const GET_SAVED_SEARCH_DETAILS = "SET_SAVED_SEARCH_DETAILS";
export const GET_SAVED_SEARCH_DETAILS_BY_ID = "GET_SAVED_SEARCH_DETAILS_BY_ID";
export const MODIFY_SAVED_SEARCH_QUERY = "MODIFY_SAVED_SEARCH_QUERY";

// communication
export const SAVE_SHOW_MEMBERS_ON_MAP = "SAVE_SHOW_MEMBERS_ON_MAP";

//Power Outage
export const GET_COUNTY_DETAILS = "GET_COUNTY_DETAILS";
export const GET_POWER_OUTAGE_REFRESH_MAP = "GET_POWER_OUTAGE_REFRESH_MAP";

// Analysis
export const GET_ANALYSIS_DETAILS = "GET_ANALYSIS_DETAILS";

// Notifications
export const GET_NOTIFICATION_STEPS = "GET_NOTIFICATION_STEPS";
export const GET_NOTIFICATION_RESET = "GET_NOTIFICATION_RESET";
